import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { Alert, AlertColor, Slide, SlideProps, Snackbar, Stack, Typography } from '@mui/material';

interface ToastAlertProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  message: string;
  severity: string;
  duration: number | undefined;
}

const getSeverityColor = (severity: string): string => {
  if (severity === 'error') return '#FF5E56';
  if (severity === 'success') return '#33DA7F';
  else return '#FFFFFF';
};

const ToastAlert = ({ open, setOpen, message, severity, duration }: ToastAlertProps) => {

  type TransitionProps = Omit<SlideProps, 'direction'>;

  function TransitionLeft(props: TransitionProps) {
    return <Slide {...props} direction="left" />;
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Snackbar 
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={open}
      autoHideDuration={duration ?? 2500}
      onClose={handleClose}
      TransitionComponent={TransitionLeft}
    >
      <Alert icon={false} onClose={handleClose} severity={severity as AlertColor} sx={{
        width: '100%', 
        maxWidth: '400px',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          borderRadius: '4px',
          padding: '0px 0px 0px 10px', //ajust the padding to change the width of the border radius
          background: getSeverityColor(severity),
          WebkitMask:
            'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          WebkitMaskComposite: 'xor',
          maskComposite: 'exclude',
        },
      }}>
        <Stack direction='row' alignItems='flex-start' justifyContent='center'>
          {severity === 'success' ? 
            <CheckCircleIcon sx={{ color:'#00CECF', margin: '-2px 8px 0px 8px', width:'20px' }}/>
            :
            <ErrorIcon sx={{ color:'#FE2525', margin: '-2px 8px 0px 8px', width:'20px' }}/> 
          }
          <Typography sx={{
            fontFamily: 'Schibsted Grotesk',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '150%',
            color: '#086267',
          }}>{message}</Typography>
        </Stack>
        
      </Alert>
    </Snackbar>
  );
};

export default ToastAlert;